/* Smooth accordion open/close.

   Tinker animates these via `::details-content` + `interpolate-size:
   allow-keywords`, which only Chromium supports — elsewhere (Safari, Firefox)
   the panel snaps. Animating an explicit pixel height gives the same motion in
   every browser, and keeps the `open` attribute honest for accessibility. */
(() => {
  const DURATION = 380;
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const contentOf = (details) =>
    details.querySelector(':scope > .details-content') ||
    details.querySelector('.details-content');

  const animate = (details, content, opening) => {
    const start = opening ? 0 : content.scrollHeight;
    const end = opening ? content.scrollHeight : 0;

    content.style.overflow = 'hidden';
    content.style.blockSize = `${start}px`;
    content.style.opacity = opening ? '0' : '1';
    // Force a reflow so the start values are committed before transitioning.
    void content.offsetHeight;

    content.style.transition = `block-size ${DURATION}ms ${EASING}, opacity ${Math.round(
      DURATION * 0.7
    )}ms ${EASING}`;
    content.style.blockSize = `${end}px`;
    content.style.opacity = opening ? '1' : '0';

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      content.style.transition = '';
      content.style.overflow = '';
      content.style.opacity = '';
      content.style.blockSize = opening ? '' : '';
      if (!opening) details.open = false;
      details.dataset.sqAnimating = 'false';
    };

    content.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'block-size') finish();
    }, { once: true });
    // Guard against a dropped transitionend (tab backgrounded, etc.)
    setTimeout(finish, DURATION + 120);
  };

  const bind = (details) => {
    if (details.dataset.sqAccordion) return;
    const summary = details.querySelector(':scope > summary');
    const content = contentOf(details);
    if (!summary || !content) return;
    details.dataset.sqAccordion = 'true';

    summary.addEventListener('click', (event) => {
      if (reduced.matches) return; // let the browser do it instantly
      if (details.dataset.sqAnimating === 'true') {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      details.dataset.sqAnimating = 'true';

      if (details.open) {
        animate(details, content, false);
      } else {
        details.open = true;
        animate(details, content, true);
      }
    });
  };

  const scan = () =>
    document.querySelectorAll('accordion-custom details').forEach(bind);

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
